import { createLazyComponent } from '@muse-web/router'

export const AsyncAnniversaryDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-anniversary' */ './AnniversaryDialogContainer'),
    'AnniversaryDialogContainer',
)
